export const menu = {
  auctions: 'Auctions',
  awarded: 'Awarded',
  history: 'History'
}
